import { Navbar, Nav, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHome, FaHistory, FaMapSigns, FaChartBar, FaUserClock, FaUserCircle, FaUser } from 'react-icons/fa';
import { useState, useEffect } from 'react';
export default function LeftSideMenuBar() {
    const [user, setUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const profile = JSON.parse(storedUser);
            setUser(profile);
            setUserRole(profile.role);
        }
    }, []);

    return (
        <Navbar expand="lg" variant='dark'>
            <Navbar.Toggle aria-controls="basic-navbar-nav " />
            <Navbar.Collapse id="basic-navbar-nav">

                <Nav className="flex-column phmc-main" variant='pills' >
                    <Nav.Link as={Link} activeClassName='' to="/dashboard"><FaHome /> Dashboard</Nav.Link>

                    <Accordion >
                        <Accordion.Item eventKey="0">
                            <Accordion.Header style={{ backgroundColor: '#003E7E' }}><span className='phmc-main'><FaHistory />  Visitation </span></Accordion.Header>
                            <Accordion.Body style={{ backgroundColor: '#003E7E' }}>
                                {userRole && userRole !== 'OBSERVER' &&
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/visitation"> <FaUserClock /> Data Entry</Nav.Link>
                                    </Nav.Item>
                                }
                                <Nav.Item as="li">
                                    <Nav.Link as={Link} to="/visitationView"> <FaUserClock /> View/Search</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">

                                    <Accordion >

                                    </Accordion>
                                </Nav.Item>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1" >
                            <Accordion.Header ><span className='phmc-main'><FaMapSigns />  Operational </span></Accordion.Header>
                            <Accordion.Body style={{ backgroundColor: '#003E7E' }}>
                                {userRole && userRole !== 'OBSERVER' &&
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/operational"> <FaUserClock /> Data Entry</Nav.Link>
                                    </Nav.Item>
                                }
                                <Nav.Item as="li">
                                    <Nav.Link as={Link} to="/operationalView"> <FaUserClock /> View/Search</Nav.Link>
                                </Nav.Item>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header><span className='phmc-main'><FaChartBar />  Performance </span></Accordion.Header>
                            <Accordion.Body style={{ backgroundColor: '#003E7E' }}>
                                {userRole && userRole !== 'OBSERVER' &&
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/performance"> <FaUserClock /> Data Entry</Nav.Link>
                                    </Nav.Item>
                                }
                                <Nav.Item as="li">
                                    <Nav.Link as={Link} to="/performanceView"> <FaUserClock /> View/Search</Nav.Link>
                                </Nav.Item>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header><span className='phmc-main'><FaChartBar />  Fiscal </span></Accordion.Header>
                            <Accordion.Body style={{ backgroundColor: '#003E7E' }}>
                                <Nav className='ms-2 flex-column ' >
                                    {userRole && userRole !== 'OBSERVER' &&
                                        <Nav.Item as="li">
                                            <Nav.Link as={Link} to="/fiscal"> <FaUserClock /> Data Entry</Nav.Link>
                                        </Nav.Item>
                                    }
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/fiscalView"> <FaUserClock /> View/Search</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Accordion.Body>
                        </Accordion.Item>
                        {userRole && (userRole === 'APPROVER' || userRole === 'OBSERVER') &&
                            <Accordion.Item eventKey="4">
                                <Accordion.Header style={{ backgroundColor: '#003E7E' }}><span className='phmc-main'><FaHistory />  Reports </span></Accordion.Header>
                                <Accordion.Body style={{ backgroundColor: '#003E7E' }}>
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/visitationMonthReport"> <FaUserClock />Monthly Overview</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/visitationMonthDetailedReport"> <FaUserClock />Monthly Detailed</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/visitationMonthAdRentReport"> <FaUserClock />Monthly Rev Report - Ad & Rent</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/visitationAnnualReport"> <FaUserClock />Annual Overview</Nav.Link>
                                    </Nav.Item>

                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/visitationAnnualAdRentReport"> <FaChartBar /> Annual Rev Report - Ad & Rent</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/siteAnnualReport"> <FaChartBar /> Site Annual  Report</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/siteAssociateAnnualReport"> <FaChartBar /> Site Associate Annual Report</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/siteAnnualProgrammingReport"> <FaChartBar /> Site Annual Programming Report</Nav.Link>
                                    </Nav.Item>
                                </Accordion.Body>
                            </Accordion.Item>
                        }
                        {userRole && userRole === 'APPLICATION_MANAGER' &&
                            <Accordion.Item eventKey="5">
                                <Accordion.Header><span className='phmc-main'><FaUserCircle />  Admin </span></Accordion.Header>
                                <Accordion.Body style={{ backgroundColor: '#003E7E' }}>
                                    <Nav.Item as="li">
                                        <Nav.Link as={Link} to="/admin"> <FaUser />Manage Users</Nav.Link>
                                    </Nav.Item>
                                </Accordion.Body>
                            </Accordion.Item>
                        }
                    </Accordion>


                </Nav>
            </Navbar.Collapse>
        </Navbar >
    );
}